<template>
  <div class="list flex col-center row-between">
    <div class="flex col-center flex-wrap">
      <div class="score-setting">
        <div class="item-body">
          <span class="item-body__label">评审总分值：</span>
          <span class="item-body__content">
            {{ getContent({ value: scoreSetting.scoreSum }) }}
          </span>
        </div>
        <el-divider direction="vertical" />
        <div class="item-body">
          <span class="item-body__label">评分方案：</span>
          <span class="item-body__content">
            自动算分
          </span>
        </div>
      </div>
      <div class="flex flex-wrap" style="width: 100%;">
        <div class="item-body m-b-12">
          <span class="item-body__label">评标基准价设置：</span>
          <span class="item-body__content">
            {{
              getContent({
                value: scoreSetting.benchPriceType,
                dict: bidReviewBasePriceSettingDict
              })
            }}
          </span>
        </div>
        <template v-if="showPercentage">
          <el-divider class="m-b-12" direction="vertical" />
          <div class="item-body m-b-12">
            <span class="item-body__label">百分比设置：</span>
            <span class="item-body__content">
              {{ scoreSetting.percentage }}%
            </span>
          </div>
        </template>
      </div>
      <div
        v-if="showPercentage"
        class="item-body one-line flex col-stretch m-b-12"
      >
        <span class="item-body__label">扣分机制设置：</span>
        <span class="item-body__content">
          <div class="m-b-12">
            投标报价每高于评标基准价的1%扣{{ scoreSetting.highUnitLessScore }}分
          </div>
          <div>
            投标报价每低于评标基准价的1%扣{{ scoreSetting.lowUnitLessScore }}分
          </div>
        </span>
      </div>
      <div class="item-body one-line flex col-stretch">
        <span class="item-body__label">计算公式：</span>
        <span class="item-body__content">
          <div
            v-for="(item, index) in formula"
            :key="index"
            class="formula-item"
          >
            {{ item }}
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { bidReviewBasePriceSettingDict } from '@/dictionary/project/kpb-project'

export default {
  name: 'AutomaticScoringDetail',

  props: {
    // 评审办法
    reviewWay: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  data() {
    return {
      bidReviewBasePriceSettingDict
    }
  },

  computed: {
    scoreSetting() {
      return {
        scoreSum: this.reviewWay.scoreSum,
        ...this.reviewWay.autoScoring
      }
    },

    // 需要设置百分比
    showPercentage() {
      const entry =
        bidReviewBasePriceSettingDict.translate(
          this.scoreSetting.benchPriceType
        ) || {}
      return entry.needPercentage
    },

    // 计算公式
    formula() {
      const entry =
        bidReviewBasePriceSettingDict.translate(
          this.scoreSetting.benchPriceType
        ) || {}
      return entry.formula ? entry.formula(this.scoreSetting) : ''
    }
  },

  methods: {
    getContent({ value, dict, fixed2 }) {
      if (dict) {
        return dict.translate(value).label || '-'
      } else if (!isNaN(value) && fixed2) {
        return parseFloat(value).toFixed(2) || '0.00'
      } else {
        return value || '-'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  ::v-deep .el-divider--vertical {
    margin: 0 16px;
  }

  .item-body {
    flex-shrink: 0;
    &.one-line {
      width: 100%;
      flex-grow: 1;
    }

    .item-body__label {
      color: $third-text-color;
    }
    .item-body__content {
      color: $text-color;
      word-break: break-all;
      text-align: justify;
    }
  }
}

.score-setting {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 0 24px;
  border-bottom: 1px solid $border-color;
  margin-bottom: 24px;
}

.formula-item {
  &:not(:last-child) {
    margin-bottom: 12px;
  }
}
</style>
